import { Vector as VectorLayer } from "ol/layer";
import { GeoJSON } from "ol/format";
import VectorSource from "ol/source/Vector";
import { bbox as bboxStrategy, all } from "ol/loadingstrategy";
import * as turf from "@turf/turf";
import Polygon from "ol/geom/Polygon";
import { toLonLat } from "ol/proj";

function addVectorLayer(
  map,
  name,
  baseUrl,
  typeName,
  dataProj,
  featureProjection,
  bbox,
  authorization,
  geometry,
  olStyle
) {
  return new Promise((resolve) => {
    var vector = null;

    function sourceLoader(extent, resolution, projection) {
      var url = baseUrl;
      url += "/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=";
      url += typeName;
      url += "&outputFormat=application/json";
      if (bbox === true) {
        var proj = projection.getCode();
        url += "&bbox=" + extent.join(",") + "," + proj;
      }

      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      if (authorization) {
        xhr.setRequestHeader("Authorization", "Basic " + btoa(authorization));
      }
      var onError = function () {
        if (extent) {
          vectorSource.removeLoadedExtent(extent);
        }
      };

      xhr.onerror = onError;
      xhr.onload = function () {
        if (xhr.status === 200) {
          vectorSource.addFeatures(
            vectorSource.getFormat().readFeatures(xhr.responseText)
          );
          resolve(vector);
        } else {
          onError();
        }
      };
      xhr.send();
    }

    var vectorSource = new VectorSource({
      format: new GeoJSON({
        dataProjection: dataProj,
        featureProjection: featureProjection,
      }),
      loader: sourceLoader,
      strategy: bbox === true ? bboxStrategy : all,
    });

    if (!bbox) {
      //console.log("load : " + name);
      sourceLoader(null, null, null);
    }
    vector = new VectorLayer({
      source: vectorSource,
      declutter: false,
      title: name,
    });
    vector.set("geometry", geometry);

    if (olStyle !== undefined) {
      vector.setStyle(olStyle);
    }

    map.addLayer(vector);
  });
}

function nearestFeaturePolygons(coordinate, featureArray) {
  var point = turf.point(coordinate);
  var format = new GeoJSON();
  var feature = null;
  var stop = false;

  featureArray.forEach((tempFeature) => {
    if (!stop) {
      var polygon = format.writeFeatureObject(tempFeature);

      var intersection = turf.booleanPointInPolygon(point, polygon);

      if (intersection) {
        feature = tempFeature;
        stop = true;
      }
    }
  });
  return feature;
}

function turfPolygonFromExtent(extent) {
  //:ol/proj.transformExtent à voir
  var geom = new Polygon([
    [
      [extent[0], extent[1]],
      [extent[2], extent[1]],
      [extent[2], extent[3]],
      [extent[0], extent[3]],
      [extent[0], extent[1]],
    ],
  ]);

  var poly = geom.transform("EPSG:3857", "EPSG:4326");
  var polygon = turf.polygon(poly.getCoordinates());

  return polygon;
}

function nearestFeatureLineStrings(coordinate, layer) {
  var feature = null;

  //Calc extent source
  var zoneSource = layer.getSource();
  var extent = zoneSource.getExtent();
  var polygon = turfPolygonFromExtent(extent);

  //Calc point
  var coord = toLonLat(coordinate).map(function (val) {
    return val.toFixed(12);
  });
  var point = turf.point(coord);

  //Intersection
  var intersection = turf.booleanPointInPolygon(point, polygon);
  if (intersection) {
    feature = zoneSource.getClosestFeatureToCoordinate(coordinate);
  }

  return feature;
}

function simpleReverseGeocoding(url, lon, lat, callbackSucess, callbackError) {
  fetch(url + "/reverse?format=json&lon=" + lon + "&lat=" + lat)
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      callbackSucess(json);
    })
    .catch(function (error) {
      callbackError(error);
    });
}

function simpleGeocoding(url, location, callbackSucess, callbackError) {
  try {
    fetch(url + "/search?format=json&q='" + location)
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        callbackSucess(json);
      });
  } catch (err) {
    callbackError(err); // Failed to fetch
  }
}

export {
  addVectorLayer,
  nearestFeaturePolygons,
  nearestFeatureLineStrings,
  simpleReverseGeocoding,
  simpleGeocoding,
};
